import React, { useEffect, useState } from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { AiOutlineClose } from "react-icons/ai";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { baseUrl } from "../../Environments/environment";
import { apiClient } from "../../api";
import { toast } from "react-toastify";
import messageSound from "../../Assets/windows_sms.mp3";

const ReasonModal = ({ isOpen, onClose, request, onRejectionSuccess ,propertyNotificationSoundEnabled}) => {
  const [showLoading, setShowLoading] = useState(true);
  //   const guestStatus = request.guestStatus.currentStatus;
  const { selectedPropertyId } = useProperty();
  const [selectedCountry, setSelectedCountry] = useState({
    code: request?.guestId?.countryCode ? request?.guestId.countryCode : "+1",
  });
  const [countryCode, setCountryCode] = useState(
    request?.guestId.countryCode || "+1"
  );
  const [phoneNumber, setPhoneNumber] = useState(
    request?.guestId.phoneNumber || undefined
  );
  const [firstName, setFirstName] = useState(
    request?.guestId.firstName || undefined
  );
  const [lastName, setLastName] = useState(
    request?.guestId.lastName || undefined
  );
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");
  const messageAudio = new Audio(messageSound);

  useEffect(() => {
    if (request) {
      setShowLoading(true);
      setPhoneNumber(
        request?.guestId.phoneNumber ? request?.guestId.phoneNumber : ""
      );
      setFirstName(
        request?.guestId.firstName ? request?.guestId.firstName : ""
      );
      setLastName(request?.guestId.lastName ? request?.guestId.lastName : "");
      setCountryCode(
        request?.guestId.countryCode ? request?.guestId.countryCode : "+1"
      );
      setSelectedCountry({
        ...selectedCountry,
        code: request?.guestId.countryCode
          ? request?.guestId.countryCode
          : "+1",
      });
      setShowLoading(false);
    }
  }, [request, isOpen]);

  useEffect(() => {
    console.log("Reply :- ", reason);
  }, [reason]);

  useEffect(() => {
    console.log("Request :- ", request);
  }, [request]);

  if (!isOpen) {
    return null;
  }

  const handleRejctioin = async () => {
    console.log(reason,propertyNotificationSoundEnabled);
    setIsLoading(true);
    let url;
    let updatedStatus = {
      requestStatus: "Declined",
      reason,
    };
    if (
      request?.requestType === "lateCheckOut" ||
      request?.requestType === "earlyCheckIn"
    ) {
      url = `${baseUrl}/checkInOutRequest/${selectedPropertyId}/${request.guestId._id}/${request._id}`;
      try {
        const response = await apiClient.patch(url, updatedStatus);
        console.log("Response :-", response);
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
          if(propertyNotificationSoundEnabled){
            messageAudio.play();
          }
          toast.success(`Status updated to Declined`);
          onRejectionSuccess();
        }
      } catch (error) {
        console.error("Error while rejecting ");
        onClose();
      } finally {
        setIsLoading(false);
      }
    } else if (request?.requestType === "houseKeeping") {
      url = `${baseUrl}/guest/houseKeepingRequest/${selectedPropertyId}/${request.guestId._id}/${request._id}`;
      try {
        const response = await apiClient.patch(url, updatedStatus);
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
        toast.success(`Status updated to ${updatedStatus}`);
        onRejectionSuccess();
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to update status. Please try again.";
        toast.error(errorMessage);
        onClose();
      } finally {
        setIsLoading(false);
      }
    } else if(request?.requestType === "Upgrade Room") {
      url = `${baseUrl}/guest/upgradeRoomRequest/${selectedPropertyId}/${request.guestId._id}/${request._id}`;
      try {
        const response = await apiClient.patch(url,updatedStatus);
        if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
        toast.success("Status Updated To Declined");
        onRejectionSuccess();
      } catch(error) {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to update status. Please try again.";
        toast.error(errorMessage);
        onClose();
      } finally {
        setIsLoading(false);
      }
    } else {
      url = `${baseUrl}/addOnsRequest/${selectedPropertyId}/${request.guestId._id}/${request._id}`;
      try {
        const response = await apiClient.put(url, updatedStatus);
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        if(propertyNotificationSoundEnabled){
					messageAudio.play();
				}
        toast.success(`Status updated to Declined`);
        onRejectionSuccess();
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to update status. Please try again.";
        toast.error(errorMessage);
        onClose();
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-0 rounded-lg shadow-xl lg:w-[70vh] max-h-[90vh] flex flex-col">
        <div
          className="overflow-y-auto px-8 pt-8 space-y-7"
          style={{ maxHeight: "calc(90vh - 72px)" }}
        >
          {showLoading ? (
            <div className="flex flex-row justify-center items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-x-2">
                  <h2 className="text-lg font-semibold">Deny Request</h2>
                </div>

                <button
                  onClick={() => {
                    onClose();
                  }}
                  className="text-gray-600 hover:text-gray-900"
                >
                  <AiOutlineClose size={20} />
                </button>
              </div>
              <div className="w-full space-y-4">
                <div className="space-y-1">
                  <label className="h-full flex items-center font-bold justify-between py-1 mb-1 bg-white rounded-l-md text-sm">
                    Name
                  </label>
                  <div className="relative">
                    <div className="relative w-[120px]">
                      <p className="block text-black">
                        {`${firstName} ${lastName}`}{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Phone Number
                  </label>
                  <div className="flex">
                    <div className="relative w-[120px]">
                      <p className="h-full flex items-center justify-between py-2 bg-white rounded-l-md text-sm">
                        {`${countryCode} ${phoneNumber}`}{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Request Type
                  </label>
                  <div className="relative">
                    <div className="relative w-[120px]">
                      <p className="block text-black">
                        {/* {request?.addOnData?.name || "N/A"} */}
                        {request?.requestType
                          ? {
                              houseKepping: "House Keeping",
                              lateCheckOut: "Late CheckOut",
                              earlyCheckIn: "Early CheckIn",
                            }[request.requestType] || request.requestType
                          : request?.addOnData?.name}
                      </p>
                    </div>
                  </div>
                </div>
                {(request?.requestType === "earlyCheckIn" ||
                  request?.requestType === "lateCheckOut") && (
                  <div className="space-y-1">
                    <label className="block text-[13px] font-semibold text-black mb-1">
                      Requested Time
                    </label>
                    <div className="relative">
                      <div className="relative w-[120px]">
                        <p className="block text-black">
                          {new Date(
                            request?.requestType === "lateCheckOut"
                              ? request.lateCheckOutDateTime
                              : request.earlyCheckInDateTime
                          ).toLocaleString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="space-y-1">
                  <label className="block text-[13px] font-semibold text-black mb-1">
                    Reason
                  </label>
                  <div className="relative">
                    <textarea
                      onChange={(e) => setReason(e.target.value)}
                      className="block w-full rounded-md border mb-3 border-gray-300 px-3 py-1 focus:border-indigo-500 focus:ring-indigo-500 resize-none overflow-y-auto text-[13px] placeholder:text-gray-900"
                      rows={3}
                      placeholder="Reason for Rejection"
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Sticky Button */}
        <div className="sticky bottom-0 bg-white px-8 py-4 border-t border-gray-200">
          <div className="flex justify-end">
            <button
              onClick={handleRejctioin}
              className={`lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600`}
              disabled={isLoading}
            >
              {isLoading ? "Denying..." : `Deny`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;
